<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">Example Component</div>

          <div class="card-body">
            I'm an example component.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { checkValidCurrencyStr, dateFormat, dataTranslations as dt } from "../utils"
import { breakpoint, notificationErrors } from "../utils"
const props = defineProps({
  modelValue: Object
})
const emit = defineEmits(['update:modelValue'])

const { t, n, locale } = useI18n()

const isMobile = computed(() => breakpoint.value.xs)

// 圖床網址（src/config/.env）
const imgUrl = computed(() => process.env.IMG_PROXY || null)

const getData = async () => {
  window.fullPageLoading("show")
  try {
    // const resp = await _api_getOrders(filterParams)
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}

</script>
